angular.module('leanlaw').directive('main', () => ({
  replace: true,
  template: require("./views/main.html"),
  controller: 'MainController'
})).factory('global', ['$q', function ($q) {
  const d = $q.defer();
  return {
    ready: d.promise,
    go: () => d.resolve()
  };
}]).controller('MainController', ['$state', '$scope', '$rootScope', '$timeout', 'userService', 'printPreview', 'leanLawAuthenticate', 'leanLawAuth', 'clientMatterManager', 'ModalService', 'global', function ($state, $scope, $rootScope, $timeout, userService, printPreview, leanLawAuthenticate, leanLawAuth, clientMatterManager, ModalService, global) {
  $scope.print = printPreview;
  $rootScope.$on('$stateChangeStart', (event, toState) => {
    $scope.wizard = toState.name.indexOf('setup') === 0;
  });
  $scope.ready = false;
  const openChat = () => {
    if (window.HubSpotConversations) {
      window.HubSpotConversations.widget.open();
    }
  };
  $scope.openChat = openChat;
  $scope.open = () => {
    $scope.subscription = true;
    if ($scope.me.features?.maxio) {
      return $state.go('maxio');
    }
    return $state.go('subscription');
  };
  leanLawAuthenticate.authenticate().then(() => {
    global.go();
    userService.me().then(me => {
      $scope.me = me;
      if (!me.id) {
        return fail();
      }
      if (!me.company || me.company.name === 'My Firm') {
        return register();
      }
      $scope.domain = leanLawAuth.domain;
      $scope.me = me;
      const {
        status,
        subscription
      } = me.company;
      if (me.features.disabled || me.disabled) {
        // user is disabled
        $scope.locked = {
          title: `User Account Disabled`,
          message: `Your LeanLaw account was disabled. Please contact your administrator or contact LeanLaw if this is unexpected or if you would like to re-enable the account.`
        };
      } else if (trialExpired(status, subscription)) {
        // firm trial expired
        $scope.locked = {
          title: `Trial Expired`,
          message: `Your LeanLaw trial has expired. Please start a subscription by using 'Open Subscription" below or contact us if you need your trial extended.`,
          subscription: me.permissions.firm.setup
        };
      } else if (me.features.suspended || status === 'inactive' || status === 'suspended') {
        $scope.locked = {
          title: `Account Suspended`,
          message: `Your LeanLaw subscription has been suspended, probably due to invalid or deleted payment information. Please update your payment information to resume using LeanLaw.`,
          subscription: me.permissions.firm.setup
        };
      } else if (status === 'disabled' || status === 'churned') {
        $scope.locked = {
          title: `Account Disabled`,
          message: `Your LeanLaw subscription was cancelled. Please update your payment information to resume using LeanLaw.
                Firm data is subject to deletion after one hundred days of cancellation`,
          subscription: me.permissions.firm.setup
        };
      } else if (status === 'delete') {
        $scope.locked = {
          title: `Account Deleted`,
          message: `Your LeanLaw account is scheduled for deletion. If this is a mistake or if you wish to recover it, please contact us ASAP.`
        };
      }
      if ($scope.locked) {
        $rootScope.$on("subscription-started", () => {
          // If subscription is succesfully started, reload the page
          window.location.href = '/';
        });
      } else {
        $scope.ready = true;
        //return clientMatterManager.hydrate();
      }
      return true;
    }).catch(fail);
  });
  function trialExpired(status, subscription) {
    return status === 'expired' || status === 'delete' && subscription.trialEndDate || subscription.trial && !subscription.trialEndDays;
  }
  function register() {
    $scope.ready = true;
    $timeout(() => ModalService.showModal({
      template: require("../modules/modals/register/template.html"),
      inputs: {},
      bodyClass: "show-modal-overlay",
      controller: "RegisterModalController"
    }).then(modal => {
      modal.element.modal();
      modal.close.then(() => {});
    }), 50);
  }
  function fail() {
    const dialog = bootbox.dialog({
      closeButton: false,
      title: "<span class='fa fa-frown-o'></span> Something Went Wrong",
      message: `<p>We were unable to load your account information. This is often the result of a security precaution and may require you to sign out and sign back into LeanLaw.</p>
            <p style='float:left'>
            <a href data-ll-contact-leanlaw>Contact LeanLaw</a></p><p style='float:right;'><a href="${leanLawAuth.domain}/account/logoff">Sign Out</a></p>`
    });
    // CSP blocks inline handlers, and Angular doesn't compile bootbox markup, so ng-click won't work here.
    dialog.on('click', '[data-ll-contact-leanlaw]', event => {
      event.preventDefault();
      openChat();
    });
  }
}]);